export default __webpack_public_path__ + "static/media/aqi_5.33904835.svg";